import YoutubePlayerChunk from './YoutubePlayerChunk/YoutubePlayerChunk';
import ThirdPartyScriptsChunk from './ThirdPartyScripts/ThirdPartyScripts';
import PagePartsChunk from './PagePartsChunk/PagePartsChunk';
import ModalConnectionChunk from './ModalConnectionChunk/ModalConnectionChunk';
import isThirdPartyDisabled from '../../shared/services/UrlQueryService';
import MediaQueries from '../../shared/helpers/MediaQueries';

/*
 * Document Ready
 * */
export default class InitChunks {
  constructor() {
    /*
     * Primary script
     * */
    // Header
    InitChunks.importHeaderChunks();

    // Banner
    InitChunks.importBannerServiceChunks();

    /*
     * Secondary script
     * */
    if (MediaQueries.mobileMedia.matches) {
      // Load files for Mobile
      document.addEventListener(
        'touchstart',
        () => {
          InitChunks.importsChunks();
        },
        { once: true, passive: true }
      );
    } else {
      // Load files for other
      InitChunks.importsChunks();
    }

    /*
     * After load page script
     * */
    window.addEventListener(
      'load',
      () => {
        // Add Youtube Player in page
        new YoutubePlayerChunk();

        // Add Third Party Scripts (skip if ?disable_tracking)
        if (!isThirdPartyDisabled()) {
          new ThirdPartyScriptsChunk();
        }

        // Add Page Parts
        new PagePartsChunk();

        // Add Modal Connection
        new ModalConnectionChunk();
      },
      { passive: true }
    );
  }

  public static importsChunks(): void {
    // Footer
    InitChunks.importFooterChunks();

    // Load style CSS for correct device
    InitChunks.importResponsiveServiceChunks();

    // Input Password
    InitChunks.importInputPasswordManagerChunks();

    // Check Input Validity
    InitChunks.importInputValidityManagerChunks();
  }

  public static importHeaderChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../components/Header/Header'
    ).then(({ default: Header }) => {
      new Header();
    });
  }

  public static importFooterChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../components/Footer/Footer'
    ).then(({ default: Footer }) => {
      new Footer();
    });
  }

  public static importResponsiveServiceChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../shared/services/ResponsiveService'
    ).then(({ default: ResponsiveService }) => {
      new ResponsiveService();
    });
  }

  public static importInputPasswordManagerChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../components/InputPasswordManager/InputPasswordManager'
    ).then(({ default: InputPasswordManager }) => {
      new InputPasswordManager();
    });
  }

  public static importInputValidityManagerChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../components/InputValidityManager/InputValidityManager'
    ).then(({ default: InputValidityManager }) => {
      new InputValidityManager();
    });
  }

  public static importBannerServiceChunks() {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ResponsiveService' */ '../../Services/Banner/BannerService'
    ).then(({ default: BannerService }) => {
      new BannerService();
    });
  }
}
